import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export type AppRole = "trader" | "investor" | "ib" | "admin";

interface UserRoleData {
  role: AppRole;
  status: string;
  loading: boolean;
  hasRole: boolean;
}

export const useUserRole = (): UserRoleData => {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["user-role", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      const { data, error } = await supabase
        .from("user_roles")
        .select("role, status")
        .eq("user_id", user.id)
        .limit(1)
        .maybeSingle();

      if (error) {
        console.error("Error fetching user role:", error);
        return null;
      }
      return data;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });

  return {
    role: (data?.role as AppRole) ?? "trader",
    status: data?.status ?? "active",
    loading: isLoading,
    hasRole: data !== null && data !== undefined,
  };
};
